<!-- 控销-推广设置 -->
<template>
  <div>

    <div class="classification">
      <div class="header">
        <div class="left_topic">推广设置</div>
      </div>
      <div class="form-setting">
        <el-form ref="form" label-position="left" label-width="200px" :model="form" :inline="true"
          style="text-align: left">

          <el-row>
            <el-col>
              <el-form-item prop="breedUpperLimit" label="业务员选品数">
                <el-input v-model="form.breedUpperLimit" placeholder="请输入" clearable size="small" style="width:150px"
                  type="number"  />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="extendServiceChargeScale" label="平台收取商家推广佣金的服务费比例">
                <el-input v-model="form.extendServiceChargeScale" placeholder="请输入" clearable size="small"
                  style="width:150px" type="number" />
                <span class="rt">
                  %
                </span>
                <span class="text">
                  举例：商家设置推广佣金30%，该参数为10%，则平台收取30%*10%*=3%的推广服务费
                </span> 
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="salesmanExtendServiceChargeScale" label="下级业务员推广佣金（推广佣金的比例）">
                <el-input v-model="form.salesmanExtendServiceChargeScale" placeholder="请输入" clearable size="small"
                  style="width:150px" type="number" />
                <span class="rt">
                  %
                </span>
                <span class="text">
                  举例：商家设置推广佣金30%，该参数为90%，则下级推广业务员收取30%*90%*（1-个税比例）的推广佣金；
上级推广业务员收取30%*（1-90%）*（1-个税比例）的推广佣金
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="salesmanBasicServiceChargeScale" label="下级业务员基础佣金（订单的比例）">
                <el-input v-model="form.salesmanBasicServiceChargeScale" placeholder="请输入" clearable size="small"
                  style="width:150px" type="number" />
                <span class="rt">
                  %
                </span>
                <span class="text">
                  举例：该参数为1%，则诊所的每个订单，平台都给将他拉新的业务员1%*（1-个税比例）的基础佣金
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="salesmanSuperiorsBasicServiceChargeScale" label="上级业务员基础佣金（下级业务员基础佣金的比例）">
                <el-input v-model="form.salesmanSuperiorsBasicServiceChargeScale" placeholder="请输入" clearable size="small"
                  style="width:150px" type="number" />
                <span class="rt">
                  %
                </span>
                <span class="text">
                  举例：该参数为10%，则诊所的每个订单，平台都给将他拉新的业务员1%*（1-个税比例）的基础佣金以后，

再给他上级业务员1%*10%*（1-个税比例）的基础佣金
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="salesmanIndividualIncomeTaxScale" label="业务员个税比例">
                <el-input v-model="form.salesmanIndividualIncomeTaxScale" placeholder="请输入" clearable size="small"
                  style="width:150px" type="number" />
                <span class="rt">
                  %
                </span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="accountOpeningBonus" label="开户奖励">
                <el-input v-model="form.accountOpeningBonus" placeholder="请输入" clearable size="small" style="width:150px"
                  type="number" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-form-item prop="firstOrderBonus" label="首单奖励">
                <el-input v-model="form.firstOrderBonus" placeholder="请输入" clearable size="small" style="width:150px"
                  type="number" />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="btnBox">
            <!-- <el-button size="small" @click="handleClose">返回</el-button> -->
            <el-button type="primary" size="small" @click="submit">保存并提交</el-button>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
 
import { mapGetters } from 'vuex'

import { querySalesExtendSettings, salesExtendSettings,salesExtendSettingsUpdate } from "@/api/externalSalesRule";

import avater from "/public/img/default.png";
export default {
  components: { MyTable },
  data() {
    return {
      avater: avater,
      form: {
        breedUpperLimit: '',
        extendServiceChargeScale: '',
        salesmanExtendServiceChargeScale: '',
        salesmanBasicServiceChargeScale: '',
        salesmanSuperiorsBasicServiceChargeScale: '',
        salesmanIndividualIncomeTaxScale: '',
        accountOpeningBonus: '',
        firstOrderBonus: '',
      },
      rules: {
        breedUpperLimit: [{ required: true, message: '请填写业务员选品数', trigger: 'blur' }],
        extendServiceChargeScale: [{ required: true, message: '请填写推广服务费比例', trigger: 'blur' }],
        salesmanExtendServiceChargeScale: [{ required: true, message: '请填写业务员所占推广费比例', trigger: 'blur' }],
        salesmanBasicServiceChargeScale: [{ required: true, message: '请填写业务员基础服务费比例', trigger: 'blur' }],
        salesmanSuperiorsBasicServiceChargeScale: [{ required: true, message: '请填写业务员上级基础服务费比例', trigger: 'blur' }],
        salesmanIndividualIncomeTaxScale: [{ required: true, message: '请填写业务员个税比例', trigger: 'blur' }],
        accountOpeningBonus: [{ required: true, message: '请填写开户奖励', trigger: 'blur' }],
        firstOrderBonus: [{ required: true, message: '请填写首单奖励', trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() { this.query() },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {

    query() {
      querySalesExtendSettings({}).then((res) => {
        this.form.id = res.id;
        this.form.breedUpperLimit = res.breedUpperLimit; //业务员品种上限
        this.form.extendServiceChargeScale = res.extendServiceChargeScale; //推广服务费比例
        this.form.salesmanExtendServiceChargeScale = res.salesmanExtendServiceChargeScale; //业务员推广服务费比例
        this.form.salesmanBasicServiceChargeScale = res.salesmanBasicServiceChargeScale; //业务员基础服务费比例
        this.form.salesmanSuperiorsBasicServiceChargeScale = res.salesmanSuperiorsBasicServiceChargeScale; //业务员上级基础服务费比例
        this.form.salesmanIndividualIncomeTaxScale = res.salesmanIndividualIncomeTaxScale; //业务员个税比例
        this.form.accountOpeningBonus = res.accountOpeningBonus; //开户奖励
        this.form.firstOrderBonus = res.firstOrderBonus; //首单奖励
      });
    },
    submit() { 
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { breedUpperLimit,
            extendServiceChargeScale,
            salesmanExtendServiceChargeScale,
            salesmanBasicServiceChargeScale,
            salesmanSuperiorsBasicServiceChargeScale,
            salesmanIndividualIncomeTaxScale,
            accountOpeningBonus,
            firstOrderBonus } = this.form;
          let params = {};
          params.breedUpperLimit = breedUpperLimit;
          params.extendServiceChargeScale = extendServiceChargeScale;
          params.salesmanExtendServiceChargeScale = salesmanExtendServiceChargeScale;
          params.salesmanBasicServiceChargeScale = salesmanBasicServiceChargeScale;
          params.salesmanSuperiorsBasicServiceChargeScale = salesmanSuperiorsBasicServiceChargeScale;
          params.salesmanIndividualIncomeTaxScale = salesmanIndividualIncomeTaxScale;
          params.accountOpeningBonus = accountOpeningBonus;
          params.firstOrderBonus = firstOrderBonus;
          if (this.form.id) {
            params.id = this.form.id;
            salesExtendSettingsUpdate(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');

              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            salesExtendSettings(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');

              } else {
                this.$message.error(res.msg)
              }
            })
          } 
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }, 
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

    .el-link {
      // margin: 5px;
    }
  }
}

.form-setting {
  margin: 20px;
}

.btnBox {
  width: 50%;
  display: flex;
  justify-content: flex-start;
}

.rt {
  margin-left: 5px;
  margin-right: 10px;
}

.text {
  color: #8c8c8c;
}
</style>
